import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { MapHelperService } from "src/services/map-helper.service";
import { IconLoadMapService } from "src/services/maps/features/IconLoad-Map.service";

@Injectable({
    providedIn: "root",
})
export class BaseMapService {

    public mapReady$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public iconsReady$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private mapHelperService: MapHelperService,
        private iconLoadMapService: IconLoadMapService
    ) {}

    //#region ------ Creación de mapa base -------

    createBaseMap(lat: number, lng: number, zoom: number): void {
        this.mapHelperService.createBaseMap(lat, lng, zoom);
    }

    async loadMapIcons(): Promise<void> {
        await this.iconLoadMapService.LoadMapixMapIcons();
        this.iconsReady$.next(true);
    }

    startPresentationMode(): void {
        this.mapHelperService.StartPresentationMode();
    }

    //#endregion

    //#region ------ Estado del mapa -------

    setMapSourcesAsReady(loadedMapName: string): void {
        this.mapHelperService.setMapSourcesAsReady(loadedMapName);
    }


    addMapStyleLoadVerifier(loadedMapName: string): void {
        this.mapHelperService.AddMapStyleLoadVerifier(loadedMapName);
    }


    notifyMapReady(): void {
        this.mapReady$.next(true);
    }

    //#endregion

    //#region ------ Manejo de eventos del mapa -------


    addEventOnMapLoad(callback: () => void): void {
        this.mapHelperService.addEventOnMapLoad(callback);
    }

    addEventOnMapClick(callback: (event: any) => void): void {
        this.mapHelperService.addEventOnMapClick(callback);
    }

    addEventOnMap(eventType: string, callback: (event?: any) => void): void {
        this.mapHelperService.addEventOnMap(eventType, callback);
    }

    removeEventFromMap(eventType: string, callback: (event?: any) => void): void {
        this.mapHelperService.RemoveEventFromMap(eventType, callback);
    }

    //#endregion

    //#region ------ Controles del mapa -------

    addMapboxPlaces(): void {
        this.mapHelperService.AddMapboxPlaces();
    }

    removeMapboxPlaces(): void {
        this.mapHelperService.RemoveMapboxPlaces();
    }

    addControlNavigation(): void {
        this.mapHelperService.AddControlNavigation();
    }

    addControlFullScreen(): void {
        this.mapHelperService.AddControlFullScreen();
    }

    addControlGeolocalization(): void {
        this.mapHelperService.AddControlGeolocalization();
    }

    //#endregion

    //#region ------ Controles de cámara / vista -------

    startTour(): void {
        this.mapHelperService.startTour();
    }

    fitBounds(geometry: any, padding: number = 100): void {
        this.mapHelperService.FitBounds(geometry, padding);
    }

    initialFly(lat: string, lng: string, zoom: string, pitch: number = 0): void {
        this.mapHelperService.InitialFly(lat, lng, zoom, pitch);
    }

    flyToCameraFast(lat: string, lng: string, zoom: string, pitch: number = 55): void {
        this.mapHelperService.FlyToCameraFast(lat, lng, zoom, pitch);
    }

    flyToCamera(lat: string, lng: string, zoom: string, pitch: number = 80): void {
        this.mapHelperService.FlyToCamera(lat, lng, zoom, pitch);
    }

    rotationCamera(): void {
        this.mapHelperService.RotationCamera();
    }

    //#endregion

    //#region ------ Métodos de utilidad -------

    turnOffTrafficLayer(): void {
        this.mapHelperService.toggleTraficLayer("none");
    }

    clearPopupEvents(mainClassName: string): void {
        this.mapHelperService.clearPopupEvents(mainClassName);
    }

    //#endregion
}
